/**
 * Centralized configuration module for all environment-specific URLs
 */

const appBaseUrl = import.meta.env.VITE_APP_BASE_URL || 'https://dev-app.flixorder.de'
const apiBaseUrl = import.meta.env.VITE_APP_API_BASE_URL || 'https://dev-console-api.flixorder.de/v1'
const stripeDashboardUrl = import.meta.env.VITE_STRIPE_DASHBOARD_URL || 'https://dashboard.stripe.com'

/**
 * DATEV online — connecting a company, the submission history — runs only where
 * DATEV has approved our client. Until production approval that is dev and stage
 * (the sandbox). Everything else, including an unset VITE_MODE, counts as
 * production. The manual export and its settings are not affected.
 */
export const isDatevOnlineEnabled = (mode: string | undefined): boolean =>
  mode === 'dev' || mode === 'stage'

export const config = {
  app: {
    baseUrl: appBaseUrl,
  },
  api: {
    baseUrl: apiBaseUrl,
  },
  stripe: {
    dashboardUrl: stripeDashboardUrl,
  },
  features: {
    datevOnline: isDatevOnlineEnabled(import.meta.env.VITE_MODE as string | undefined),
  },
}

export default config
